module.exports = __webpack_public_path__ + "static/media/monster.55792d00.png";